import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=54b868dd&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=54b868dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b868dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54b868dd')) {
      api.createRecord('54b868dd', component.options)
    } else {
      api.reload('54b868dd', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=54b868dd&scoped=true&", function () {
      api.rerender('54b868dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2M9bl5iNKbb38/JS/comp/PopupDialog.vue"
export default component.exports